import Footer from './components/footer/Footer.vue';
import Drawer from './components/drawer/Drawer.vue';
import Header from './components/header/Header.vue';
import Webpush from '../pages/profile/webpush/Webpush.vue';


export default {
  data() {
    return {
      menuActive: false,
    };
  },
  components: {
    Drawer,
    Header,
    Webpush,
    Footer,
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    isBlocked() {
      return !!(this.$store.state.user
        && this.$store.state.user.blocked_at !== null);
    },
    userIsChecked() {
      return true;
    },
    extranet() {
      return this.$store.state.settings.extranet === true;
    },
    loading() {
      return this.$store.state.loading;
    },
    epsCartLength() {
      return this.$store.state.eps.cartLength;
    },
    layout() {
      return this.$store.state.settings.layout;
    },
    bgUrl() {
      return this.$store.state.settings.bgUrl;
    },
    showWebpushPopup() {
      return 'Notification' in window
        && this.$store.state.user
        && this.$store.state.settings.webpush === true
        && this.$store.state.webpush.webpushPopupOpened === true
        && this.$store.state.webpush.webpushFirebaseToken === null
        && this.$store.state.webpush.webpushDeclinedAt === null;
    },
    news() {
      return this.$store.state.settings.news === true;
    },
    instructions() {
      return this.$store.state.settings.instructions === true;
    },
    sales() {
      return this.$store.state.settings.sales === true;
    },
    courses() {
      return this.$store.state.settings.courses === true;
    },
    tickets() {
      return this.$store.state.settings.module_tickets === true;
    },
    isBannersOn() {
      return this.$store.state.settings.module_banners === true;
    },
    isShopOn() {
      return this.$store.state.settings.shop === true;
    },
    /** Верхнее меню */
    topMenuItems() {
      if (this.isAuthenticated && !this.userIsChecked) {
        return [
          {
            title: 'Профиль',
            path: '/profile',
            icon: 'user-circle',
            showIcon: true,
            showTitle: true,
          },
        ];
      }
      if (this.isAuthenticated && !this.isBlocked) {
        const menu = [
          {
            title: 'Личный кабинет',
            path: '/dashboard',
            icon: 'home',
            mobileTitle: 'Личный кабинет',
            optionalClass: 'menu__link--home',
            showIcon: true,
            showTitle: true,
          },
          {
            title: 'Профиль',
            path: '/profile',
            icon: 'user-circle',
            showIcon: true,
            showTitle: true,
          },
          {
            title: 'Призы',
            path: '/prizes',
            icon: 'gift',
            showIcon: true,
            showTitle: true,
          },
          {
            title: 'Заказы',
            path: '/orders',
            icon: 'file-alt',
            showIcon: true,
            showTitle: true,
          },
        ];
        this.news && menu.push({
          title: 'Новости',
          path: '/news',
          icon: 'comment-dots',
          showIcon: true,
          showTitle: true,
        });
        this.instructions && menu.push({
          title: 'Баллы',
          path: '/instructions',
          icon: 'chart-bar',
          showIcon: true,
          showTitle: true,
        });
        this.courses && menu.push({
          title: 'Обучение',
          path: '/courses',
          icon: 'user-graduate',
          showIcon: true,
          showTitle: true,
        });
        this.isShopOn && menu.push({
          title: 'Товары',
          path: '/shop',
          icon: 'shopping-cart',
          showIcon: true,
          showTitle: true,
        });
        return menu;
      }
      return [];
    },
    /** Левое мобильное меню в дровере */
    leftMenuItems() {
      if (this.isAuthenticated) {
        let menu = [];
        if (!this.userIsChecked) {
          menu = [
            {
              title: 'Главная страница',
              path: '/',
              icon: 'home',
            },
            {
              title: 'Помощь',
              path: '/feedback',
              icon: 'question-circle',
            },
          ];
        } else if (!this.isBlocked) {
          menu = [
            {
              title: 'Личный кабинет',
              path: '/dashboard',
              icon: 'home',
            },
            {
              title: 'Профиль',
              path: '/profile',
              icon: 'user-circle',
            },
            {
              title: 'Призы',
              path: '/prizes',
              icon: 'gift',
            },
            {
              title: 'Заказы',
              path: '/orders',
              icon: 'file-alt',
            },
          ];
          this.news && menu.push({
            title: 'Новости',
            path: '/news',
            icon: 'comment-dots',
          });
          this.isShopOn && menu.push({
            title: 'Товары',
            path: '/shop',
            icon: 'shopping-cart',
          });
          this.instructions && menu.push({
            title: 'Баллы',
            path: '/instructions',
            icon: 'chart-bar',
            optionalClass: 'long-title',
          });
          this.courses && menu.push({
            title: 'Обучение',
            path: '/courses',
            icon: 'user-graduate',
          });
          menu.push({
            title: 'Помощь',
            path: '/feedback',
            icon: 'question-circle',
          });

          if (this.tickets) {
            menu.push({
              title: 'Чат',
              path: '/tickets',
              icon: ['fa', 'paper-plane'],
            });
          }
        } else {
          menu = [
            {
              title: 'Главная страница',
              path: '/',
              icon: 'home',
            },
            {
              title: 'Помощь',
              path: '/feedback',
              icon: 'question-circle',
            },
          ];
        }
        return menu;
      }
      if (this.extranet) {
        return [];
      }
      return [
        {
          title: 'Главная страница',
          path: '/',
          icon: 'home',
        },
        {
          title: 'Помощь',
          path: '/feedback',
          icon: 'question-circle',
        },
        {
          title: 'Войти',
          path: '/',
          icon: 'sign-in-alt',
        },
      ];
    },
  },
  methods: {
    UserLogout() {
      this.$store.dispatch('UserLogout');
      this.$router.push('/');
    },
    menuShow() {
      this.menuActive = !this.menuActive;
    },
  },
  created() {
    this.$store.dispatch('GetSettings');
    this.$store.commit('SetLoading', false);
    this.isBannersOn && this.$store.dispatch('banners/GetBannersList');
  },
};
